import { render, staticRenderFns } from "./select.vue?vue&type=template&id=1b25afd5&scoped=true&lang=pug&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=1b25afd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b25afd5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsLottie: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/widgets/lottie.vue').default})
